<template>
  <div>
    <loadingCube v-if="!loading_worker" :loadingMessage="'Loading News Article'"></loadingCube>
    <div class="row">
      <div class="col-12">
        <b-card v-if="news" header="View News Article" header-tag="h4" body-class="mb-3 pb-2 record_card_body">
          <div class="row">
            <div class="col-12">
              <div class="row">
                <!-- Title -->
                <div class="col-lg-3 form-group">
                  <label class="form-label">Title</label>
                  <p class="mt-3">
                    <span>{{ news.title }}</span>
                  </p>
                </div>

                <!-- Category -->
                <div class="col-12 form-group">
                  <label class="form-label">Category</label>
                  <p class="mt-3">{{ getCategoryName(news.article_category_id) }}</p>
                </div>

                <!-- Content -->
                <div class="col-12 form-group">
                  <label class="form-label">Content</label>
                  <div class="mt-3 bg-white" v-html="news.content"></div>
                </div>

                <!-- Authorisation Component -->
                <div class="col-12">
                  <authorisedComponent :params="news" />
                </div>
              </div>
            </div>
          </div>
        </b-card>
        <div v-else>
          <p>No news article found.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loadingCube from "loaders/record_loader"; // Ensure this path is correct

export default {
  components: {
    loadingCube,
    authorisedComponent: {
  name: 'authorisedComponent',
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      saving: false
    }
  },
  computed: {
    canAuthorize() {
      // Check if the user has the permission and is not the author of the article
      const isAuthor = this.params.author_id === this.$store.state.auth.me.id;
      return this.$store.state.auth.me.permissions.includes('news_articles_set_publish') && !isAuthor;
    }
  },
  template: `
    <div class="col-12" v-if="params.published === true">
      <button v-if="canAuthorize && params.authorised === false" 
              class="btn orcaBtn bg-primary" 
              @click="authorisedNews" 
              :disabled="saving">
        <span v-if="saving" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i></span>
        <span v-else><i class="far fa-hand-point-right"></i> Authorize</span>
      </button>

      <span v-else-if="params.authorised === true" class="text-primary">
        Authorized by: {{ params.authorised_by.first_name }} {{ params.authorised_by.surname }}
      </span>
      
      <button v-else-if="!canAuthorize" class="btn orcaBtn bg-secondary" :disabled="true">
        <span>You don't have permission to authorize</span>
      </button>

      
      <span class="text-warning" v-else>Author must click publish first</span>
    </div>
    <span v-else>Author must click publish first</span>
  `,
  methods: {
  authorisedNews() {
    // Confirmation dialog
    const confirmed = confirm('Are you sure you want to authorize this article? It will then be visible on the site.');
    if (!confirmed) {
      return; // Exit if the user cancels
    }

    if (!this.canAuthorize) {
      this.$snotify.error('You do not have permission to authorize this news article.');
      return;
    }

    this.saving = true;
    let paramsNews = {
      ...this.params,
      authorised: 1,
      authorised_by_id: this.$store.state.auth.me.id,
    };

    axios.patch(this.crmApiPath + 'news/' + this.params.id, paramsNews)
      .then(response => {
          this.params.authorised = response.data.authorised;
          this.params.authorised_by = response.data.authorised_by;
          this.params.users_authorised_name = response.data.authorised_by.first_name + ' ' + response.data.authorised_by.surname;
          this.$snotify.success('News Article Updated');

          axios.patch(this.crmApiPath + 'news/website/save/' + this.params.id)
          .then(() => {
              this.$snotify.success('News Article Updated on WEB');
          })
          .catch(error => {
            console.log(error);
            this.$snotify.error('Error authorizing news on WEB');
            this.saving = false;
          });
      })
      .catch(error => {
        console.error(error);
        this.$snotify.error('Error authorizing news article');
      })
      .finally(() => {
        this.saving = false;
      });
    }
  }
}

  },
  data() {
    return {
      loading_worker: false,
      news: null,
      categories: [], // Assuming you may want to fetch the category names
    };
  },
  created() {
    const newsId = this.$store.state.news.current_edit_news_article_id; // Ensure this ID is set correctly

    // Fetch news article data
    axios.get(`${this.crmApiPath}news/${newsId}`)
      .then(response => {
        if (!response.data) {
          this.$snotify.error('No data returned for the news article');
          return;
        }
        this.news = response.data;
        this.loading_worker = true;
      })
      .catch(error => {
        console.error('Error fetching news article:', error);
        this.$snotify.error('Failed to load news article data');
      });

    // Fetch categories if needed
    axios.get(`${this.crmApiPath}crm/attributes/news_article_category`)
      .then(res => {
        this.categories = res.data;
      });
  },
  methods: {
    getCategoryName(categoryId) {
      const category = this.categories.find(cat => cat.id === categoryId);
      return category ? category.value : 'Unknown Category'; // Adjust 'value' as necessary to fit your data structure
    }
  }
};
</script>

<style scoped lang="scss">
.vvERROR {
  color: red;
  font-size: 0.9em;
}
</style>
